<template>
  <div class="community-member-wrapper">
    <Modal :show="modalVisible" :message="modalText" @close="closeModal" />
    <div class="community-member" v-if="!showCTA">
      <div class="community-member-top">
        <span class="wallet">
          <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"><path d="M30 4.49C30 2.01 28.041 0 25.625 0H4.375a4.304 4.304 0 00-3.116 1.342.606.606 0 00-.173.19A4.536 4.536 0 000 4.49v16.675c.094 2.518 1.766 4.684 4.133 5.354l13.948 3.363c.316.077.64.117.964.118a3.352 3.352 0 002.145-.747 3.71 3.71 0 001.31-2.957V13.863c-.003-2.452-1.597-4.602-3.899-5.26L5.07 4.774a.95.95 0 01-.657-.685.979.979 0 01.25-.927.92.92 0 01.907-.241S9.506 4.037 9.945 4.16a.29.29 0 00.081.011h15.598a.95.95 0 01.937.963.95.95 0 01-.937.962H19.08a.315.315 0 00-.31.277.32.32 0 00.227.352l.107.03a7.143 7.143 0 013.625 2.428c.061.077.153.12.25.12h2.645a.95.95 0 01.938.962.95.95 0 01-.938.962h-1.297a.312.312 0 00-.294.415c.23.716.348 1.465.351 2.22v8.905c0 .178.14.321.313.321h.927c2.416 0 4.375-2.01 4.375-4.49V4.49zM19.375 19.24c0 1.417-1.12 2.566-2.5 2.566s-2.5-1.149-2.5-2.566c0-1.417 1.12-2.565 2.5-2.565s2.5 1.148 2.5 2.565z" fill="#FFF" fill-rule="nonzero"/></svg>
          $ {{ walletAmount }}
        </span>
        <div class="community-member-top-left" :class="member.class">
        </div>
        <div class="community-member-top-right">
          <div class="community-member-top-right-inside">

            <template v-if="currentQuestion">
              <p class="question">{{ currentQuestionText }}</p>
              <ul>
                <li v-for="answer in currentQuestion.answers" :key="answer.id" @click="selectAnswer(answer)" :class="{'active' : answer == selectedAnswer}">{{ answer.text }}</li>
              </ul>
            </template>

            <template v-else>
              <h3>{{ member.name }}</h3>
              <p>
                <span class="budget"><strong>Income:</strong> ${{ member.income }}</span>
                <span class="budget"><strong>Expenses:</strong> ${{ member.expenses }}</span>
                <span class="budget"><strong>Budget:</strong> ${{ member.income - member.expenses }}</span>
              </p>
              <p>{{ member.description }}</p>
            </template>
          </div>
        </div>
      </div>
      <div class="community-member-bottom">
        <a href="#" class="btn btn-red-open" @click="back($event)">Go Back</a>
        <a href="#" class="btn btn-red" @click="next($event)">Next</a>
      </div>
    </div>
    <CTA v-if="showCTA" />
  </div>
</template>

<script>
import Simulation from '../services/SimulationService';
import Modal from '@/components/Modal.vue';
import CTA from '@/components/CTA.vue';
var vsprintf = require('sprintf-js').vsprintf;

export default {
  name: 'CommunityMember',
  data() {
    return {
      member: {},
      walletAmount: 0,
      currentQuestion: null,
      selectedAnswer: null,
      questionHistory: [],

      showCTA: false,

      modalVisible: false,
      modalText: 'Hello',
    };
  },
  components: {
    Modal,
    CTA,
  },
  mounted() {
    this.member = Simulation.getMember({slug: this.$route.params.slug});
    this.resetMember();
  },
  computed: {
    currentQuestionText(){
      var walletAmount = this.walletAmount;
      console.log(walletAmount);
      // evaluate tokens and insert into string
      if(this.currentQuestion.textTokens){
        var evaldTokens = this.currentQuestion.textTokens.map((val) => {
          val = eval(val);
          return val;
        });
        return vsprintf(this.currentQuestion.text, evaldTokens);
      }
      return this.currentQuestion.text;
    }
  },
  methods: {
    resetMember(){
      this.walletAmount = this.member.income - this.member.expenses;
      this.currentQuestion = null;
    },
    next(e){
      e.preventDefault();
      if(this.currentQuestion){
        // no answer
        if(!this.selectedAnswer){
          return;
        }

        var historyPayload = {
          questionId: this.currentQuestion.id,
          wallet: Simulation.getWalletAmount(this.member.id, this.currentQuestion.id, this.selectedAnswer.id),
        };

        this.selectedAnswer.resultActions.forEach((action) => {
          switch(action.type) {
            case 'wallet':
              this.updateWallet(action.amount);
              break;
            case 'modal':
              this.showModal(action.text);
              break;
            case 'question':
              setTimeout(() => {
                this.loadQuestion(action.questionId);
              }, 500);
              this.questionHistory.push(historyPayload);
              break;
            case 'cta':
              setTimeout(() => {
                this.loadCTA();
              }, 500);
              break;
          }
        })

      }
      else{
        this.loadQuestion(this.member.firstQuestion);
      }
    },
    back(e){
      e.preventDefault();
      if(this.questionHistory.length > 0){
        var previous = this.questionHistory.pop();
        this.loadQuestion(previous.questionId);
        this.updateWallet(-previous.wallet);
      }
      else if(this.currentQuestion){
        this.resetMember();
      }
      else{
        this.$router.push({ name: 'Simulation'});
      }
    },
    loadQuestion(questionId){
      this.currentQuestion = Simulation.getQuestion(this.member.id, questionId);
      this.selectedAnswer = null;
    },
    selectAnswer(answer){
      this.selectedAnswer = answer;
    },
    updateWallet(difference){
      var newAmount = this.walletAmount + difference;

      // animate this
      var intervalSeconds = Math.min(80, [1500/difference]); // don't want this to take forever on larger amounts
      if(this.walletAmount < newAmount) {
          var interval1 = setInterval(() => {
              if (this.walletAmount >= newAmount) {
                  clearInterval(interval1);
                  return;
              }
              this.walletAmount++;
          }, intervalSeconds);
      }
      if(newAmount < this.walletAmount) {
          var interval2 = setInterval(() => {
              if (newAmount >= this.walletAmount) {
                  clearInterval(interval2);
                  return;
              }
              this.walletAmount--;
              if(this.walletAmount < 0){
                this.loadCTA();
              }
          }, intervalSeconds);
      }
    },
    loadCTA(){
      // this.$router.push({ name: 'SimulationCTA'});
      this.showCTA = true;
    },
    showModal(message){
      this.modalVisible = true;
      this.modalText = message;
    },
    closeModal(){
      this.modalVisible = false;
      this.modalText = '';
    }
  }

}
</script>
